import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer } from "@mui/material";
import { UnconfiguredRules } from "system/types/interfaces";
import { NotConfiguredRow } from "./NotConfiguredRow";

interface NotConfiguredTableProps {
  notConfiguredRules: UnconfiguredRules[];
  onAdd: (ruleName: string) => void;
  readOnlyViewer: boolean;
}

export const NotConfiguredTable: React.FC<NotConfiguredTableProps> = ({ notConfiguredRules, onAdd, readOnlyViewer }) => {
  return (
    <TableContainer sx={{ backgroundColor: "#1b1a19", borderRadius: 2, opacity: 0.5 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "#333", fontWeight: "bold" }}>
            <TableCell sx={{ color: "#fff", width: "50px" }}></TableCell>
            <TableCell sx={{ color: "#fff", width: "300px" }}>Rule</TableCell>
            <TableCell sx={{ color: "#fff", minWidth: "130px" }}>Default Value</TableCell>
            <TableCell sx={{ color: "#fff" }}>Description</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {notConfiguredRules.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} sx={{ color: "#aaa", textAlign: "center" }}>
                No default configurations found for this package
              </TableCell>
            </TableRow>
          ) : (
            notConfiguredRules.map((item) => <NotConfiguredRow key={item.name} item={item} onAdd={onAdd} readOnlyViewer={readOnlyViewer} />)
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
